import React from 'react';
interface AgreexaMarkProps {
  className?: string;
  showTagline?: boolean;
  tone?: 'light' | 'dark';
}
/**
 * The Agreexa wordmark used consistently to signal the parent trust infrastructure.
 * Kept typographic and restrained — never a "software logo".
 */
export function AgreexaMark({
  className = '',
  showTagline = false,
  tone = 'dark'
}: AgreexaMarkProps) {
  const primary = tone === 'dark' ? 'text-ink' : 'text-paper';
  const secondary = tone === 'dark' ? 'text-stone-500' : 'text-stone-300';
  return <span className={`inline-flex flex-col leading-none ${className}`} data-id="element-31">
      <span className={`font-serif font-600 tracking-tightest ${primary}`} style={{
      fontWeight: 600
    }} data-id="element-32">
        AGREEXA
        <sup className="ml-0.5 text-[0.5em] align-super" data-id="element-33">®</sup>
      </span>
      {showTagline && <span className={`eyebrow mt-1 ${secondary}`} style={{
      letterSpacing: '0.24em'
    }} data-id="element-34">
          The Global Trust Infrastructure
        </span>}
    </span>;
}